import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Toast } from "../../shared/Toast";
import API from "../../services/api";
import Select from "react-select";
import { SlButton } from "@shoelace-style/shoelace/dist/react";

function AddAdPartner(props) {
  const { flag, editdata,loadData,setShow } = props;
  const form1 = useForm({ mode: "onChange", defaultValues: {
    ad_partner_image:"",
    ad_partner_name:"",
    sales_poc:[]
  } });
  const [image, setImage] = useState("");
  const [imgurl, setImgurl] = useState("");
  const [salesPoc, setSalesPOC] = useState([]);
  const handleImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (
        e.target.files[0].type === "image/svg+xml" 
      ) {
        setImage(e.target.files[0]);
      } else {
        Toast("error", "Only jpg, jpeg, webp, png formats accepted");
      }
    } else {
      if (flag === "edit") {
        setImgurl(editdata.img_urls);
      } else {
        setImgurl("");
      }
    }
  };
  const handleUploadImage = async () => {
    const formData = new FormData();
    formData.append("files", image);
    try {
      let res = await API({
        url: "/upload/svg",
        method: "POST",
        responseType: "json",
        data: formData,
      });
      if (res.code === 200) {
        form1.setValue('ad_partner_image', image)
        setImgurl(res.data);
        Toast("success", "Image uploaded successfully");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onSubmit = async (data) => {
    try {
      if (flag === "add") {
        let res = await API({
          url: "/adpartners/add",
          method: "POST",
          responseType: "json",
          data: {
            ad_partner_name: data.ad_partner_name ,
            img_url: imgurl,
            sales_poc:data.sales_poc?.value
          },
        });
        if(res.code === 200){
            Toast("success", "Ad Partner added successfully");
            setShow(false);
            loadData()
        }
        else{
            Toast('error', res.data.message)
        }
      }
      if (flag === "edit") {
        let res = await API({
            url: "/adpartners/edit",
            method: "POST",
            responseType: "json",
            data: {
              ad_partner_name: data.ad_partner_name ,
              img_url: image ?  imgurl : editdata?.img_url,
              sales_poc:data.sales_poc?.value,
              ad_partner_id:editdata.ad_partner_id
            },
          });
          if(res.code === 200){
              Toast("success", "Ad Partner edited successfully");
              setShow(false);
              loadData()
          }
          else{
            Toast('error', res.data.message)
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const fetchSales = async()=>{
    try {
        let res = await API({
            url: "/adpartners/sales",
            method: "POST",
            responseType: "json",
            data: {},
          });
        if(res.code === 200){
            setSalesPOC(res.data)
        }
    } catch (error) {
        console.error(error);
    }
  }
  useEffect(()=>{
    fetchSales()
  },[])


  useEffect(() => {
    if (image) handleUploadImage();
  }, [image]);


  useEffect(() => {
    if (flag === "edit") {
      form1.setValue('ad_partner_name', editdata?.ad_partner_name);
        console.log(salesPoc)
      const poc = salesPoc.find(item => item.value === editdata?.sales_poc);
      console.log(poc);
      if (poc) {
        form1.setValue('sales_poc', poc);
      }
    }
  }, [flag, editdata,salesPoc]);
  

  return (
    <>
      <form onSubmit={form1.handleSubmit(onSubmit)}>
        <div className="my-3">
          <label className="form-label">Ad Partner Name</label>
          <Controller
            name="ad_partner_name"
            rules={{ required: "Ad Partner name is required!" }}
            control={form1.control}
            render={({ field }) => {
              return <input type="text" className="form-control" {...field} placeholder="Enter Ad Partner Name" />;
            }}
          />
          {form1.formState?.errors?.ad_partner_name && (
            <div className="text-red-600">
              {form1.formState?.errors?.ad_partner_name?.message}
            </div>
          )}
        </div>
        <div>
          <label className="form-label">Ad Partner Image</label>
            <Controller
            name="ad_partner_image"
            rules={{ required: flag === "add" ? "Logo is required!" : false}}
            control={form1.control}
            render={({ field }) => {
                return (
                <input
                    type="file"
                    className="form-control"
                    onChange={(e) => {
                    field.onChange(e); // Register file with react-hook-form
                    handleImage(e);    // Your custom logic
                    }}
                    ref={field.ref}
                />
                );
            }}
            />

          {form1.formState?.errors?.ad_partner_image && (
            <div className="text-red-600">
              {form1.formState?.errors?.ad_partner_image?.message}
            </div>
          )}
          {imgurl !== "" ? (
            <span>{`${imgurl}`}</span>
          ) : (
            flag === "edit" && <span>{`${editdata?.img_url}`}</span>
          )}
        </div>
        <div className="my-3">
          <label className="form-label">Sales POC</label>
          <Controller
            name="sales_poc"
            rules={{ required: "Sales POC is required!" }}
            control={form1.control}
            render={({ field }) => {
              return <Select {...field} options={salesPoc} />;
            }}
          />

          {form1.formState?.errors?.sales_poc && (
            <div className="text-red-600">
              {form1.formState?.errors?.sales_poc?.message}{" "}
            </div>
          )}
        </div>
        <div className="my-3">
          <SlButton
            type="submit"
            variant="primary"
            className="w-full"
            disabled={form1.isSubmitting}
          >
            {form1.formState?.isSubmitting ? (
              <>
                {" "}
                <svg class="mr-3 size-5 animate-spin" viewBox="0 0 24 24"></svg>
                Submitting..{" "}
              </>
            ) : (
              "Submit"
            )}
          </SlButton>
        </div>
      </form>
    </>
  );
}

export default AddAdPartner;
